export default [
  {
    path: '',
    component: () => import('@/views/infra/InfraWrapper.vue'),
    children: [
      {
        path: '/infraestructure/purchase-service',
        name: 'purchaseService',
        component: () => import('@/views/infra/purchaseService/Main.vue'),
      },
      {
        path: '/infraestructure/purchase-service/:id',
        name: 'purchaseServiceDetail',
        component: () =>
          import('@/views/infra/purchaseService/components/Detail.vue'),
      },
    ],
  },
];
